import { firebase } from '@firebase/app';
import '@firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyAR6x6UxFrGV_JNdcekUUmCPYTJIMR6tyo',
  authDomain: 'srhr-sexkampen.firebaseapp.com',
  databaseURL: 'https://srhr-sexkampen.firebaseio.com',
  projectId: 'srhr-sexkampen',
  storageBucket: 'srhr-sexkampen.appspot.com',
  messagingSenderId: '182821468486',
  appId: '1:182821468486:web:dbf991b51d37e49d640d47'
};

/* const app = firebase.initializeApp({
  apiKey: 'AIzaSyAR6x6UxFrGV_JNdcekUUmCPYTJIMR6tyo',
  authDomain: 'frontend.srhr.stickybeat.se',
  databaseURL: 'https://srhr-sexkampen.firebaseio.com',
  projectId: 'srhr-sexkampen'
}); */

const app = firebase.initializeApp(firebaseConfig);

export const partyDb = app.firestore();
export const firebaseApp = app;
